import React from 'react';
import './RisingNowCard.css';

import gainIcon from '../assets/gain-icon.png';
import barterKingIcon from '../assets/barterking-icon.png';
import merchantStarIcon from '../assets/merchantstar-icon.png';
import creatorFlameIcon from '../assets/creatorflame-icon.png';
import guardianIcon from '../assets/guardian-icon.png';
import uptrendIcon from '../assets/uptrend-icon.png';
import placeholderProfile from '../assets/placeholder-profile.png';

const BADGE_META = {
  BARTER_KING: {
    label: 'Barter King',
    icon: barterKingIcon,
  },
  MERCHANT_STAR: {
    label: 'Merchant Star',
    icon: merchantStarIcon,
  },
  CREATOR_FLAME: {
    label: 'Creator Flame',
    icon: creatorFlameIcon,
  },
  PI_GUARDIAN: {
    label: 'Pi Guardian',
    icon: guardianIcon,
  },
};

function RisingNowCard({ data, onOpenLeaderboard }) {
  const items = Array.isArray(data?.items) ? data.items : [];

  if (!data?.showCard || items.length < 2) return null;

  const handleOpen = () => {
    if (typeof onOpenLeaderboard === 'function') {
      onOpenLeaderboard();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleOpen();
    }
  };

  return (
    <div
      className="rising-now-card"
      onClick={handleOpen}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
<div className="rising-now-header">
  <div className="rising-now-title-wrap">
    <span className="rising-now-title">RISING NOW</span>
    <img
      src={gainIcon}
      alt="Rising"
      className="rising-now-title-icon"
    />
  </div>

  <span className="rising-now-subtitle">Last 24hr</span>
</div>

      <div className="rising-now-list">
        {items.map((item) => {
          const meta = BADGE_META[item.badgeType] || {
            label: item.badgeLabel || item.badgeType,
            icon: null,
          };

          return (
            <div
              key={`${item.badgeType}-${item.username}`}
              className="rising-now-row"
            >
              <div className="rising-now-badge-block">
                {meta.icon ? (
                  <img
                    src={meta.icon}
                    alt={meta.label}
                    className="rising-now-badge-icon"
                  />
                ) : null}

                <span className="rising-now-badge-label">{meta.label}</span>
              </div>

              <div className="rising-now-user-block">
                <img
                  src={item.profilePic || placeholderProfile}
                  alt={item.name || item.username}
                  className="rising-now-avatar"
                  onError={(e) => {
                    e.currentTarget.src = placeholderProfile;
                  }}
                />

                <div className="rising-now-fullname-wrap">
                  <span className="rising-now-fullname">
                    {item.name || item.username}
                  </span>

                  <img
                    src={uptrendIcon}
                    alt="Up"
                    className="rising-now-uptrend-icon"
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default RisingNowCard;
